module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sectiontop"
  }, [_c('i', [_vm._v("It’s like a lion at the door;")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('i', [_vm._v("And when the door begins to crack,")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('i', [_vm._v("It’s like a stick across your back;")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('i', [_vm._v("And when your back begins to smart,")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('i', [_vm._v("It’s like a penknife in your heart…")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("(A Nursery Rhyme)")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12606d43","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/frontmatter002.vue
// module id = 66
// module chunks = 0